import { render, staticRenderFns } from "./AdminActionAdd.vue?vue&type=template&id=02ad253a&"
import script from "./AdminActionAdd.vue?vue&type=script&lang=js&"
export * from "./AdminActionAdd.vue?vue&type=script&lang=js&"
import style0 from "./AdminActionAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports